import Phaser from 'phaser'
import {
    CST
} from '../CST'

export default class Boot extends Phaser.Scene {

    constructor() {
        super(CST.SCENES.BOOT);
    }

    preload() {
        this.load.image("loading_bg", "assets/loading_background.png");
        
        this.load.spritesheet({
            key: "loading",
            url: "assets/sprite-loading.png",
            frameConfig: {
                frameWidth: 76.44,
                frameHeight: 78
            }
        });
    }

    create() {
        this.scene.start(CST.SCENES.PRELOAD);
    }

    upload() {}
}